import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguagesService {
  chatbot_lang:string;
  private subject=new BehaviorSubject<any>({
    chatbot_lang:""
    })
  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe((params) => {
        this.chatbot_lang = params.lang;
        if (params.lang) {
        localStorage.setItem("chatbot_lang",params.lang);
        this.update_language(params.lang)
        }
        console.log("chatbot_lang",params.lang);
    });
   }

  update_language(language:string){
    this.subject.next({content:language})
  }
  get_language():Observable<any>{
    return this.subject;
  }
}
